import React from "react";
import { Flex, Text } from "@mantine/core";
import StarRatings from "react-star-ratings";

export default function StarDisplay({ starSize = 20, value = 0 }) {
  const starsToMake = Math.round((value / 20) * 100) / 100;

  if (!value) return null;

  return (
    <div className="star-display">
      <StarRatings
        rating={starsToMake}
        starDimension={`${starSize}px`}
        starRatedColor="var(--mantine-color-blue-4)"
        starSpacing="1px"
      />
      <span>{starsToMake} / 5 stars</span>
    </div>
  );
}
